import React from "react";
import styled from "styled-components";
import * as Icon from "../../src/Components/Icon";
import TypingDots from "./TypingDots";
import BotAvatar from "./BotAvatar";
import Chatty from "../core/Chatty";
import ChatMessage from "./ChatMessage";
import ChattyAnswerInput from "./ChattyAnswerInput";
import ChattyProductResult from "./ChattyProductResult";
import ChattyResult from "./ChattyResult";
import { getQuestions } from "../ChatFlow";

const Wrapper = styled.div`
  width: 485px;
  height: 535px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  overflow: hidden;
  border-radius: 9px;
  border: 1px solid #b08963;
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2),
    0 5px 22px 4px rgba(0, 0, 0, 0.12), 0 12px 17px 2px rgba(0, 0, 0, 0.14);
  position: fixed;
  bottom: 110px;
  right: 47px;
  z-index: 10;

  @media screen and (max-width: 479px) {
    right: 0px;
    bottom: 15px;
    max-width: 300px;
    width: 100%;
    max-height: 450px;
    height: 100%;
    z-index: 1000;
  }

  & > .header {
    position: relative;
    height: 34px;
    background-color: #cca37b;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    & > p {
      font-size: 15px;
      color: #fff;
      letter-spacing: 1.5px;
    }

    & > .close-btn {
      position: absolute;
      right: 13px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

const ChattyAreaWrapper = styled.div`
  flex: 1;
  padding: 10px 10px 50px 10px;
  overflow-y: scroll;
`;

class ChattyArea extends React.Component {
  componentDidUpdate() {
    document.getElementById("rev-chat-area").scrollTo(0, 20000);
  }

  render() {
    return (
      <ChattyAreaWrapper id="rev-chat-area">
        {this.props.children}
      </ChattyAreaWrapper>
    );
  }
}

class ChattyScreen extends React.Component {
  render() {
    const { toggChatty } = this.props;
    let urlPath = window.location.pathname;
    return (
      <Wrapper>
        <div className="header">
          <p>來一杯咖啡配對吧！</p>
          <div className="close-btn" onClick={() => toggChatty()}>
            <Icon.Close size="20" color="#fff" />
          </div>
        </div>
        <Chatty
          enableDefaultSuccessMessage={false}
          questions={getQuestions(urlPath)}
        >
          {({ chatty }) => {
            const {
              messages,
              question,
              isRemoteThinking,
              onAnswer,
              finished,
              acceptedAnswers
            } = chatty;

            return (
              <>
                <ChattyArea>
                  {messages.map((m, idx) => {
                    let msg = { ...m, last: false };
                    if (idx === messages.length - 1) {
                      msg.last = true;
                    } else if (msg.from !== messages[idx + 1].from) {
                      msg.last = true;
                    }
                    return (
                      <ChatMessage
                        key={idx}
                        message={msg}
                        acceptedAnswers={acceptedAnswers}
                      />
                    );
                  })}

                  {isRemoteThinking && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start"
                      }}
                    >
                      <BotAvatar isLast />
                      <div
                        style={{
                          backgroundColor: "rgba(214,185,161,0.50)",
                          width: 60,
                          height: 30,
                          padding: "8px 12px",
                          borderRadius: 20
                        }}
                      >
                        <TypingDots />
                      </div>
                    </div>
                  )}

                  {finished && <ChattyResult answers={acceptedAnswers} />}
                </ChattyArea>
                <ChattyAnswerInput
                  disabled={isRemoteThinking || finished}
                  question={question}
                  onAnswer={onAnswer}
                />
              </>
            );
          }}
        </Chatty>
      </Wrapper>
    );
  }
}

export default ChattyScreen;
